import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { endpoints } from "@/endpoints";
import axios from "axios";
import useApiStore from "@/stores/api";
import { QR_TYPE } from "@/stores/constants";

export function useSvgQrCode() {
  const { t } = useI18n();
  const apiStore = useApiStore();

  const code = ref("");
  const w = 750;
  const h = 1000;
  const logo = `
    <svg width="295" height="65" viewBox="0 0 295 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M84.3342 3.08065H93.4837V13.4194L84.3342 9.06452V3.08065ZM28.0791 23.6613C27.3031 14.4516 19.6246 12.1613 14.4517 12.1613C7.04806 12.1613 0.695106 16.8387 0.695106 24.3548C0.759767 29.8548 4.96274 32.7258 10.1195 34.3226C17.1837 36.7581 20.0449 37.6613 20.0449 40.9516C20.1096 43.5323 17.6686 45.4193 14.8074 45.4193C13.0615 45.4193 9.50518 44.5806 9.14954 40.4677H0C0.695107 49.7419 8.72925 52.8065 14.6781 52.8065C22.7122 52.8065 29.3561 47.7903 29.2106 39.9032C29.146 31.6774 22.5021 29.871 16.3593 28.1935C12.7221 27.1452 9.92548 25.8226 9.86081 23.3871C9.86081 21.5 11.3319 19.5484 14.4033 19.5484C17.9596 19.5484 19.0104 21.6452 19.0912 23.6613H28.0791ZM39.2331 51.6129H47.833L55.1721 25.7581L62.7051 51.6129H71.305L83.6068 13.3387H74.1016L66.6332 39.9677L59.1649 14.5968H51.4056L44.0665 39.9677L36.4527 13.3387H26.9475L39.2331 51.6129ZM84.3342 51.6129H93.4837V13.3548L84.3342 17.7097V51.6129ZM178.012 35.3548C178.788 28.5968 177.01 22.5484 172.241 17.6936C168.604 13.9677 163.479 11.7903 157.628 11.7903C145.795 11.7903 137.114 21.4355 137.114 32.4032C137.114 43.1613 145.73 52.8065 157.773 52.8065C161.831 52.8065 165.678 51.6774 168.959 49.4355C172.241 47.2581 175.021 44.0161 176.864 39.7258H167.246C165.468 42.8871 162.396 44.9355 157.838 44.9355C152.487 45 146.942 41.5645 146.506 35.371H178.012V35.3548ZM146.667 28.3226C147.023 24.5161 150.806 19.5968 157.708 19.5968C164.546 19.5323 168.474 24.6613 168.83 28.3226H146.667ZM259.663 51.6129H268.812V30.4839C268.812 25.1129 271.043 20.7903 277.542 20.7258C283.975 20.7258 285.85 25.1129 285.85 30.8387V51.6129H295V28.5484C295 21.7903 292.624 12.2419 280.112 12.1613C273.258 12.0968 269.847 15.4355 268.166 18.4355C268.23 16.629 268.23 15.0161 268.23 13.3548H259.63V51.6129H259.663ZM95.5044 65H104.654V51.6129V46.5161C106.19 48.9516 110.247 52.7903 117.715 52.7903C128.967 52.7903 136.726 43.6613 136.726 32.7903C136.726 23.5161 131.068 12.1613 117.651 12.1613C111.298 12.1613 106.82 15.0968 104.104 18.9194V13.3387H95.5044V65ZM127.9 32.5161C127.9 39.0161 122.63 44.2742 116.115 44.2742C109.601 44.2742 104.331 39.0161 104.331 32.5161C104.331 26.0161 109.601 20.7581 116.115 20.7581C122.63 20.7581 127.9 26.0323 127.9 32.5161ZM228.334 38.8871L231.357 37.0161L219.734 33.371L217.778 45.371L220.931 43.4355L220.995 43.5323C224.972 49.7258 231.357 51.8226 232.198 52.0806C234.122 52.6774 236.175 53 238.308 53C249.64 53 258.838 43.8387 258.838 32.5161C258.838 21.1935 249.656 12.0323 238.308 12.0323C231.325 12.0323 225.15 15.5161 221.448 20.8387L220.721 21.8226L209.227 38.4677L209.001 38.8064C206.883 41.9839 203.262 44.0806 199.14 44.0806C192.609 44.0806 187.323 38.8065 187.323 32.2903C187.323 25.7742 192.609 20.5 199.14 20.5C205.671 20.5 210.957 25.7742 210.957 32.2903L210.924 33.6613L219.815 21.0806L219.654 0L210.957 4.67742V15.5323C207.611 13.1774 203.537 11.7903 199.14 11.7903C187.808 11.7903 178.61 20.9516 178.61 32.2742C178.61 43.5968 187.792 52.7581 199.14 52.7581C205.913 52.7581 211.927 49.4839 215.661 44.4194L215.855 44.129L217.051 42.3871L218.797 31.8226L223.323 33.2742L228.173 26.3387L228.496 25.8871C230.614 22.7581 234.219 20.6935 238.292 20.6935C244.823 20.6935 250.109 25.9677 250.109 32.4839C250.109 39 244.823 44.2742 238.292 44.2742C234.17 44.2742 230.533 42.1613 228.415 38.9677L228.334 38.8871Z" fill="black"/>
    </svg>
  `;

  const template = computed(() => {
    const config = {
      border: {
        width: 598,
        marginLeft: 83,
      },
      minRecWidth: 450,
      wordSize: 27,
    };

    const text = t("welcomeScreen.ipadPreview.defaults.scanToSignIn");

    let width = text.length * config.wordSize;
    if (width < config.minRecWidth) width = config.minRecWidth;

    const left = (config.border.width - width) / 2 + config.border.marginLeft;

    return `
      <svg width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="${w}" height="${h}" fill="white"/>
        <rect x="${config.border.marginLeft}" y="101" width="${config.border.width}" height="698" rx="24" stroke="#C3C3C3" stroke-width="4"/>
        <rect x="158" y="62" width="${config.minRecWidth}" height="77" fill="white"/>
        <rect x="${left}" y="760" width="${width}" height="77" fill="white"/>
        <svg x="133" y="196">${code.value}</svg>
        <svg x="235" y="70">${logo}</svg>
        <text
          x="383"
          y="798"
          fill="black"
          dominant-baseline="middle"
          text-anchor="middle"
          font-size="3em"
          font-family="Sans-serif"
          font-weight="100"
        >
          ${text}
        </text>
      </svg>
    `;
  });

  async function toSvgString(qrType: string, qrCode: string): Promise<string> {
    let svgString;

    if (qrType === QR_TYPE.PNG) {
      code.value = `<image href="${qrCode}" height="500" width="500"/>`;
      svgString = await base64SvgToBase64Png();
    } else {
      code.value =
        qrCode.split('<?xml version="1.0" standalone="yes"?>').pop() ?? "";
      svgString = template.value;
    }

    return svgString;
  }

  function encodeBase64(str: string) {
    return btoa(toBinaryStr(str));
  }

  function toBinaryStr(str: string) {
    const encoder = new TextEncoder();
    // 1: split the UTF-16 string into an array of bytes
    const charCodes = encoder.encode(str);
    // 2: concatenate byte data to create a binary string
    return String.fromCharCode(...charCodes);
  }

  function base64SvgToBase64Png(): Promise<string> {
    return new Promise((resolve, reject) => {
      const parser = new DOMParser().parseFromString(
        template.value,
        "text/xml"
      );

      const serializer = new XMLSerializer().serializeToString(parser);
      const encodedData = encodeBase64(serializer);
      const imgSource = `data:image/svg+xml;base64,${encodedData}`;

      const img = new Image();
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.width = w;
      canvas.height = h;

      img.onload = () => {
        context?.drawImage(img, 0, 0);
        const imgURL = canvas.toDataURL("image/png");
        resolve(imgURL);
      };

      img.onerror = () => {
        reject(new Error(t("errors.unexpected")));
      };

      img.src = imgSource;
    });
  }

  const generateQrCode = async (qrType = "png", locationId: string) => {
    return await axios.get(
      apiStore.getEndpoint("rest", endpoints.generateQrCode(locationId)),
      {
        params: {
          qrType,
        },
      }
    );
  };

  return {
    toSvgString,
    generateQrCode,
  };
}
